import application from "../application";

export default class Projects {
    /**
     *
     * @param {application} app
     */
    constructor(app) {
        this.app = app;
        this.API = app.API

        this.list = []
    }

    async refresh(){
        if( !this.app.auth.isLogged ) return;

        this.list = await this.API.getProjects()
    }

    async create(assign = false){
        var label = prompt(
            this.app.translate("projects_prompt_new")
        )

        if( label ){
            this.app.showSpinner()
            var newProject = await this.API.createProject(label)
            await this.refresh()

            // Mirar si currentConfiguration té projecte
            if( assign && this.app.currentConfiguration.projectId == null ){
                this.app.currentConfiguration.projectId = newProject.id
                await this.app.asyncProcess()
            }
            this.app.hideSpinner()
        }
    }

    async update(projectId){
        if( projectId == null ) return

        this.app.showSpinner()

        var project = await this.API.getProject(projectId)

        if( !project ) return

        var newLabel = prompt(
            this.app.translate("projects_prompt_update"),
            project.label
        )

        if( newLabel ){
            await this.API.updateProjectById(projectId, newLabel)
            await this.refresh()
        }

        this.app.hideSpinner()
    }

    async remove(projectId){
        if( projectId == null ) return

        this.app.showSpinner()

        var project = await this.API.getProject(projectId)

        if( !project ) return

        var confirmRemove = confirm(
            this.app.translate("projects_prompt_delete") +
            "\r\n\r\n" +
            "'" + project.label + "'"
        )

        if( confirmRemove ){
            await this.API.removeProject(projectId)
            await this.refresh()

            // Mirar si currentConfiguration té aquest projecte
            if( this.app.currentConfiguration.projectId == projectId ){
                this.app.currentConfiguration.projectId = null
                await this.app.asyncProcess()
            }
        }

        this.app.hideSpinner()

        if( confirmRemove ) return true;

        return false;

    }
}